import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(email, password);
      if (data.totp_required) {
        navigate('/2fa');
      } else if (data.totp_enabled === false && data.message === 'Login successful') {
        navigate('/setup-2fa');
      } else {
        navigate('/select-customer');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="card">
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <img
            src="/fcc-logo-stacked.png"
            alt="Florida Cargo Carrier"
            style={{ width: '400px', maxWidth: '80%', height: 'auto', display: 'inline-block' }}
          />
        </div>
        <p style={{ textAlign: 'center' }}>Sign in to your account</p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <div className="links">
          <Link to="/forgot-password">Forgot your password?</Link>
          <span>Need access? <Link to="/register">Request an account</Link></span>
        </div>
      </div>
    </div>
  );
};

export default Login;